import { SessionHistory } from "../types";

type LegacySessionHistory = SessionHistory & { content?: string };

export function migrateLuxorSessionHistory(
  sessions: Record<string, LegacySessionHistory>
): Record<string, SessionHistory> {
  const migrated: Record<string, SessionHistory> = {};

  for (const [key, session] of Object.entries(sessions)) {
    if (
      "importedContent" in session &&
      typeof session.importedContent === "string"
    ) {
      migrated[key] = {
        importedContent: session.importedContent,
        freeText: session.freeText ?? "",
        importedSnapshot: session.importedSnapshot ?? "",
        response: session.response ?? "",
        showEditor: session.showEditor ?? true,
        appointmentId: session.appointmentId,
        timestamp: session.timestamp,
        isArchived: session.isArchived,
      };
    } else {
      const legacyContent = session.content ?? "";
      migrated[key] = {
        importedContent: legacyContent,
        freeText: "",
        importedSnapshot: legacyContent,
        response: session.response ?? "",
        showEditor: session.showEditor ?? true,
        appointmentId: session.appointmentId,
        timestamp: session.timestamp,
        isArchived: session.isArchived,
      };
    }
  }

  return migrated;
}
